export { default } from './ExtendedIcon';
